import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import forms from "../../../../Data/Forms/Products/Brands/forms";
import headers from "../../../../Data/Forms/Products/Brands/headers";
import {
  create_product_brand,
  get_product_brand,
  update_product_brand,
} from "../../../../Controllers/Products/Brands";
import Loadercomponent from "../../../../Componets/Loader";

const BrandsForm = ({ isModal = false, onClose }) => {
  const params = useParams();
  const id = isModal ? null : params.id;

  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const brand = id
        ? await update_product_brand({ id: id, ...data?.data })
        : await create_product_brand(data?.data);

      if (brand?.status) {
        // if (id) {
        if (isModal) {
          onClose && onClose();
        } else {
          navigate(-1);
        }
        // }
        toast?.success(brand?.message);
        setButtonLoader(false);
      } else {
        setButtonLoader(false);
        if (brand?.status_code == 403) {
          window.location.href = "/unauthorized";
        } else {
          toast?.error(brand?.message);
        }
      }
    }
  };

  const handleData = (brand) => {
    let name = brand?.name ? brand?.name : "";
    let status = brand?.status ? brand?.status : 0;

    forms[0].options[0].form.value = name;
    forms[1].options[0].form.value = status;

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const brand = await get_product_brand(data);

      if (brand?.status) {
        handleData(brand?.data);
      } else {
        toast?.error(brand?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const content = (
    <Loadercomponent loader={loader}>
      <Forms
        form={values}
        setForm={setValues}
        formdata={formdata}
        buttonLoader={buttonLoader}
        isModal={isModal}
        onModalClose={onClose}
      />
    </Loadercomponent>
  );

  return isModal ? (
    content
  ) : (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      {content}
    </Header>
  );
};

export default BrandsForm;
